import { useState, useEffect } from 'react'
import { get } from '@user/store/services/crud'
import { WebformDTO } from '../typings'
import { ServiceConfig } from '@user/store/services/config'

const baseUrl = `${ServiceConfig.baseAPIUrl}/${ServiceConfig.integrations.webForm.ctmWebform}`

export const useGetCTMWebformDataOnMount = (
  webformTrackingId?: string | null,
) => {
  const [webformData, setWebformData] = useState<WebformDTO>()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true
    const execute = async () => {
      if (mounted && webformTrackingId) {
        try {
          setStatus('pending')
          const response = await get(`${baseUrl}/${webformTrackingId}`)

          if (response.ok) {
            setStatus('success')
            const webformDataResponse: WebformDTO = await response.json()
            setWebformData(webformDataResponse)
          }
        } catch (error) {
          console.error(error)
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [webformTrackingId])

  return { status, webformData }
}
